module.exports = __webpack_public_path__ + "img/blue-square-table-3.5c858af9.png";